/**
 * Selects the text within an element when the `select-on-click` attribute is specified.
 */

function initSelectOnClick() {
  const elements = document.querySelectorAll("[select-on-click]");

  elements.forEach((element) => {
    element.addEventListener("click", () => {
      window.getSelection()?.selectAllChildren(element);
    });
  });
}

document.addEventListener("DOMContentLoaded", initSelectOnClick);
